window.getCart = function() {
  $.ajax({
    url       : '/cart.js',
    type      :	'GET',
    async     : false,
    dataType  :	'json',
    success   :	function( data ) {
      if ( data.items.length > 0 ) {
        $('#cart-items').html('');
        for ( var i = 0; i < data.items.length; i++ ) {
          var product = data.items[i];
          product.price_template = Shopify.formatMoney( product.line_price );
          var item = $('#cartitem-template').tmpl( product );
          $('#cart-items').append( item );
        }
        var note = data.note != null ? data.note : '';
        $( '#cart-items' ).append( '<div class="cart-notes"><textarea name="note" id="CartSpecialInstructions" class="cart-note__input" placeholder="add a note to your order" rows="3" data-cart-notes>' + note + '</textarea></div>' );
        $( '#cart-subtotal' ).html( '<h4>Subtotal</h4><span class="subtotal-amount">' +  Shopify.formatMoney(data.items_subtotal_price) + '</span>' );
        $( '#cart-links' ).html( '<li><a href="/collections/all">Continue Shopping</a></li><li><button type="submit" name="checkout">Checkout</button></li>' );
      } else {
        $( '#cart-items' ).html( '<center><i>Your cart is currently empty.</i></center>' );
        $( '#cart-subtotal' ).html( '<h4>Subtotal</h4><span class="subtotal-amount">$0</span>' );
        $( '#cart-links' ).html( '<li class="uk-margin-auto"><a href="/collections/all">Continue Shopping</a></li>' );
      }
    },
    error     : function( err ) {
      UIkit.notification({
        message : err.responseJSON.description,
        status  : 'danger',
        pos     : 'bottom-center',
        timeout : 4000
      });
    },
    cache     : false
  });
};

window.updateCart = function( id, qty ) {
  $.ajax({
    url       : '/cart/change.js',
    type      :	'POST',
    async     : false,
    data      :	{
      id        : id,
      quantity  : qty
    },
    dataType  :	'json',
    success   :	function( data ) {
      if ( data.items.length > 0 ) {
        $('#cart-items').html('');
        for ( var i = 0; i < data.items.length; i++ ) {
          var product = data.items[i];
          product.price_template = Shopify.formatMoney( product.line_price );
          var item = $('#cartitem-template').tmpl( product );
          $('#cart-items').append( item );
        }
        var note = data.note != null ? data.note : '';
        $( '#cart-items' ).append( '<div class="cart-notes"><textarea name="note" id="CartSpecialInstructions" class="cart-note__input" placeholder="add a note to your order" rows="3" data-cart-notes>' + note + '</textarea></div>' );
        $( '#cart-subtotal' ).html( '<h4>Subtotal</h4><span class="subtotal-amount">' +  Shopify.formatMoney(data.items_subtotal_price) + '</span>' );
        $( '#cart-links' ).html( '<li><a href="/collections/all">Continue Shopping</a></li><li><button type="submit" name="checkout">Checkout</button></li>' );
      } else {
        $( '#cart-items' ).html( '<center><i>Your cart is currently empty.</i></center>' );
        $( '#cart-subtotal' ).html( '<h4>Subtotal</h4><span class="subtotal-amount">$0</span>' );
        $( '#cart-links' ).html( '<li class="uk-margin-auto"><a href="/collections/all">Continue Shopping</a></li>' );
      }
    },
    error     : function( err ) {
      UIkit.notification({
        message : err.responseJSON.description,
        status  : 'danger',
        pos     : 'bottom-center',
        timeout : 4000
      });
    },
    cache     : false
  });
};

function isHTML5(el) {
  return el && el.tagName === 'VIDEO';
}

function isIFrame(el) {
  return el && el.tagName === 'IFRAME';
}

if ( $( '.animsition' ).length ) {
  var loader = $( '.animsition' ).attr( 'data-loader' );
  
  $( '.animsition' ).animsition( {
    inClass               : 'fade-in',
    outClass              : 'fade-out',
    inDuration            : 500,
    outDuration           : 500,
    linkElement           : 'a:not([target="_blank"]):not([href=""]):not([href^="#"]):not([href^="javascript:;"]):not([class^="remove"]):not([class^="ajax-link"])',
    loading               : ( loader !== '' ) ? true : false,
    loadingParentElement  : 'body',
    loadingClass          : 'animsition-loader',
    loadingInner          : '<img src="' + loader + '" />',
    timeout               : false,
    browser               : [ 'animation-duration', '-webkit-animation-duration'],
    overlay               : false,
    overlayClass          : 'animsition-overlay-slide',
    overlayParentElement  : 'body',
    transition            : function (url) {
      window.location.href = url;
    }
  } );
};

if ( $( '#top-banner' ).length > 0 ) {
  $('.top-banner-wrapper').marquee({
    duration: 15000,
    direction: 'right'
  });
  $( '#wrapper' ).addClass( 'wrapper-top-banner' );
}

UIkit.util.on( '#cart-offcanvas', 'show', function () {
  window.getCart();
} );

$( 'body' ).on( 'click', '.product-remove', function( e ) {
  e.preventDefault();
  var id = $( this ).attr( 'data-id' );
  window.updateCart( id, 0 );
} );

$( 'body' ).on( 'click', '.button-math', function( e ) {
  e.preventDefault();
  
  var
  button	= $(this),
  id      = button.parents( '.product-quantity' ).attr( 'data-id' ),
  qty		  = button.parents( '.product-quantity' ).find( ':input[type=number]' ),
  max     = qty.attr('max') ? qty.attr('max') : 3,
  value	  = qty.val();

  if ( button.data('calc') == '+' ) {
    if ( parseInt(value) < parseInt(max) ) {
      value = parseInt(value) + 1;
    }
  } else {
    value = (value > 1) ? (parseFloat(value) - 1) : 1;
  }
  qty.val(value).trigger( 'change' );

  if ( $( this ).attr('data-cart') === 'true' ) {
    window.updateCart( id, value );
  };

} );

$( window ).on( 'load scroll', function() {
  var 
  scrTop    = $( window ).scrollTop(),
  navigate  = $( '#navigation' ),
  navHght   = navigate.outerHeight(),
  sections  = $( '.sections' );

  sections.each( function( index ) {
    var 
    sectionT  = $( this ).offset().top,
    sectionB  = sectionT + $( this ).parent( '.shopify-section' ).outerHeight( true ),
    navColor  = $( this ).attr( 'data-nav' ),
    navBckgr  = $( this ).attr( 'data-navbg' );
    
    if ( $( '#top-banner' ).length ) {
      var banH = $( '#top-banner' ).outerHeight();
      sectionT  = sectionT - parseInt( banH );
    }

    if ( index === 0 ) {
      sectionB = sectionB - parseInt( navHght );
    }
    
    if ( index === 1 ) {
      sectionT = sectionT - parseInt( navHght );
    }

    if( scrTop >= sectionT && scrTop < sectionB ) {
      navigate.attr( 'data-color', navColor );

      if ( navBckgr === 'true' ) {
        navigate.addClass( 'uk-navbar-background' );
      } else {
        navigate.removeClass( 'uk-navbar-background' );
      }
    }
  } );

} );

// video sections
if ( $( '#video-player' ).length > 0 ) {
  var
  winWid = $( window ).width(),
  vidDes = document.getElementById( 'video-player' ),
  vidMob = document.getElementById( 'video-player-mobile' );

  $( window ).on( 'load resize', function() {
    winWid = $( window ).width();
  } );

  $( document ).on( 'click', '#play-toggler', function( e ) {
    e.preventDefault();
    var isPlay = $( this ).attr( 'data-play' );
    if ( isPlay === 'true' ) {
      if ( winWid >= 960 ) {
        if ( isHTML5(vidDes) ) {
          vidDes.pause();
        } else {
          vidDes.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'pauseVideo', method: 'pause'}), '*');
        }
      } else {
        if ( isHTML5(vidMob) ) {
          vidMob.pause();
        } else {
          vidMob.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'pauseVideo', method: 'pause'}), '*');
        }
      }
      $( this ).attr( 'data-play', 'false' );
    } else {
      if ( winWid >= 960 ) {
        if ( isHTML5(vidDes) ) {
          vidDes.play();
        } else {
          vidDes.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'playVideo', method: 'play'}), '*');
        }
      } else {
        if ( isHTML5(vidMob) ) {
          vidMob.play();
        } else {
          vidMob.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'playVideo', method: 'play'}), '*');
        }
      }
      $( this ).attr( 'data-play', 'true' );
    }
  } );

  $( document ).on( 'click', '#mute-toggler', function( e ) {
    e.preventDefault();
    var isMute = $( this ).attr( 'data-mute' );
    console.log( isMute );
    if ( isMute === 'true' ) {
      if ( winWid >= 960 ) {
        if ( isHTML5(vidDes) ) {
          vidDes.pause();
        } else {
          vidDes.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'unMuteVideo', method: 'setVolume', value: 1 }), '*');
        }
      } else {
        if ( isHTML5(vidMob) ) {
          vidMob.pause();
        } else {
          vidMob.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'unMuteVideo', method: 'setVolume', value: 1 }), '*');
        }
      }
      $( this ).attr( 'data-mute', 'false' );
    } else {
      if ( winWid >= 960 ) {
        if ( isHTML5(vidDes) ) {
          vidDes.play();
        } else {
          vidDes.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'muteVideo', method: 'setVolume', value: 0 }), '*');
        }
      } else {
        if ( isHTML5(vidMob) ) {
          vidMob.play();
        } else {
          vidMob.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'muteVideo', method: 'setVolume', value: 0 }), '*');
        }
      }
      $( this ).attr( 'data-mute', 'true' );
    }
  } );
};

// features sections
if ( $( '#features' ).length > 0 && $( window ).width() > 960 ) {
  $( window ).on( 'load scroll', function() {
    var 
    winT = $( window ).scrollTop(),
    winH = $( window ).height(),
    feaT = $( '#features' ).offset().top,
    feaB = feaT + ( $( '#features' ).height() - winH ),
    bigE = $( '#big-image' );

    if ( winT >= feaT && winT < feaB ) {
      bigE.addClass('sticky');
      bigE.removeClass('bottom');
    } else if ( winT >= feaB ) {
      bigE.addClass('bottom');
      bigE.removeClass('sticky');
    } else {
      bigE.removeClass('sticky');
      bigE.removeClass('bottom');
    }

    var images = $( '#features-images .image' );
  
    images.each( function() {
      var
      imageC  = $( this ).attr( 'data-bg' ),
      imageT  = $( this ).offset().top,
      imageB  = imageT + $( this ).height();
  
      if( winT >= imageT && winT <= imageB ) {
        $( '#features' ).css( 'background-color', imageC );
      }
    });

  } );
};

// multiscroll sections
if ( $( '#multiscroll' ).length > 0 ) {
  $( document ).ready( function() {
    $('#multiscroll').multiscroll( {
      verticalCentered: true,
      scrollingSpeed: 150,
      easing: 'easeInQuart',
      menu: false,
      sectionsColor: [],
      navigation: false,
      loopBottom: false,
      loopTop: false,
      css3: true,
      paddingTop: 0,
      paddingBottom: 0,
      normalScrollElements: null,
      keyboardScrolling: true,
      touchSensitivity: 5,
    } );
  } );
}